import AuditTrail from "../../../jsx/components/Dashboard/AuditTrail/AuditTrail";

const AuditTrialWrapper = () => {
  return <AuditTrail />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.it];
export default constore(AuditTrialWrapper);
